import { Paper, Typography, CircularProgress, Box } from '@mui/material'
import { useGetCarInterestChartQuery } from 'store/dashboard'
import HorizontalLineChart from 'components/chart/HorizontalLineChart'
import ChartTitle from './ChartTitle'
import NoDataAvailable from './NoDataAvailable'
import { useTimeRange } from './TimeRangeContext'

const charts = [
  { key: 'carBrandOwnership' as const, title: 'Car Brand Ownership' },
  { key: 'carModelOwnership' as const, title: 'Car Model Ownership' },
  { key: 'brandInterest' as const, title: 'Brand Interest' },
  { key: 'carTypeInterest' as const, title: 'Car Type Interest' },
  { key: 'hyundaiModelInterest' as const, title: 'Hyundai Model Interest' }
]

export default function CarInterestHLCChart() {
  const { startDate, endDate } = useTimeRange()

  const { data, isLoading, isError, refetch, isFetching } = useGetCarInterestChartQuery({
    startDate,
    endDate
  })

  return (
    <Paper
      sx={{
        p: 2,
        height: '100%',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: 'none'
      }}
      elevation={0}
    >
      <Box>
        <ChartTitle tooltip='Customer preferences and interests across car brands, types, and models'>
          White Car Interest
        </ChartTitle>
        <Typography variant='subtitle2' color='gray'>
          Each bar = % distribution of top choices in that category
        </Typography>
      </Box>

      {isLoading || isFetching ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <CircularProgress />
        </Box>
      ) : isError ? (
        <NoDataAvailable variant='error' onRefresh={refetch} />
      ) : !data ? (
        <NoDataAvailable onRefresh={refetch} />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {(() => {
            const allEmpty = charts.every(({ key }) => !data[key] || data[key].length === 0)
            return charts.map(({ key, title }) => (
              <Box key={key}>
                <Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 2 }}>
                  {title}
                </Typography>
                {data[key] && data[key].length > 0 ? (
                  <HorizontalLineChart data={data[key]} />
                ) : (
                  <NoDataAvailable onRefresh={allEmpty ? refetch : undefined} />
                )}
              </Box>
            ))
          })()}
        </Box>
      )}
    </Paper>
  )
}
